<template>
  <div>
    <div :class="{'opened': open}" class="left-side">
      <ul class="nav" v-if="$route.name !== 'login'">
        <li class="nav--item">
          <router-link :to="{name: 'feeds'}" class="nav--link" active-class="active">
            <svg class="svg-sprite-icon svg-sprite-unstyled icon-link-6">
              <use xlink:href="@/assets/img/svg/symbol/symbol_unstyled.svg#link-6"></use>
            </svg>
            <div class="nav--text">Фиды</div>
          </router-link>
        </li>
        <li class="nav--item">
          <router-link :to="{name: 'stats'}" class="nav--link" active-class="active">
            <svg class="svg-sprite-icon svg-sprite-unstyled icon-link-4">
              <use xlink:href="@/assets/img/svg/symbol/symbol_unstyled.svg#link-4"></use>
            </svg>
            <div class="nav--text">Статистика</div>
          </router-link>
        </li>
        <li class="nav--item">
          <router-link :to="{name: 'campaigns'}" class="nav--link" active-class="active">
            <div class="nav--text">Кампании</div>
          </router-link>
        </li>
        <li class="nav--item">
          <router-link :to="{name: 'changelogs'}" class="nav--link" active-class="active">
            <div class="nav--text">Логи изменений</div>
          </router-link>
        </li>
      </ul>
      <footer class="footer">
        <a class="btn btn-gray btn-logout" @click="logout">
          <svg class="svg-sprite-icon svg-sprite-unstyled icon-logout">
            <use xlink:href="@/assets/img/svg/symbol/symbol_unstyled.svg#logout"></use>
          </svg>
          Выход
        </a>
        <div class="copyrights">© Copyright Push.House {{ (new Date()).getFullYear() }} <br>Все права защищены</div>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LeftSide',
  props: {
    open: {},
  },
  methods: {
    logout() {
      this.$auth.removeToken();
      this.$router.push({ name: 'login' });
    },
  },
};
</script>
<style lang="scss" scoped>
.left-side {
  height: 100%;
  display: flex;

  &:not(.opened) {
    display: none;
  }
}
</style>